import React from "react";

export const Logo = props => <img src={`https://client-upload.bytehogs.com/_COM/brand/${props.mobile ? "mobile-logo" : "logo"}.png`} className={"logo " + (props.className || "")} alt="RightRecruit"/>
